import React from 'react';
import { PageEmptyState } from '../../../../ui/page-empty-state/page-empty-state';
import { PageLoadingState } from '../../../../ui/page-loading-state/page-loading-state';
import { useGetRelease } from '../../api/use-get-release';
import { useCheckPromoAccess } from '../../hooks/use-check-access/use-check-promo-access';
import { useGetReleaseIdFromParams } from '../../hooks/use-get-release-id-from-params/use-get-release-id-from-params';
import { PageLayout } from '../../../../ui/page-layout/page-layout';

type ReleaseLayoutProps = {
  children: React.ReactNode;
};

export const ReleaseLayout = ({ children }: ReleaseLayoutProps) => {
  const releaseId = useGetReleaseIdFromParams();
  const { data, error, isLoading } = useGetRelease(releaseId);

  useCheckPromoAccess(data?.catNr);

  if (isLoading) {
    return <PageLoadingState />;
  }

  if (error || !data) {
    return <PageEmptyState />;
  }

  return (
    <PageLayout header={{ rightSideText: data.catNr }}>{children}</PageLayout>
  );
};
